import React from 'react';
import {Button} from './index';

const Modal = ({
  buttonType,
  children,
  closeModal,
  disabledButton,
  handleClick,
  subtitle,
  title,
}) => {
  return (
    <div>
      <div className="overlay"></div>
      <div className="modal">
        <div className="modal-titles-container">
          <p className="modal-title">{title}</p>
          <p className="modal-subtitle">{subtitle}</p>
        </div>
        {children}
        <div className="container-buttons-modal">
          <Button label="Annuler" dark onClick={closeModal} />
          <Button
            type={buttonType}
            label="Confirmer"
            onClick={handleClick}
            disabled={disabledButton}
            light
          />
        </div>
      </div>
    </div>
  );
};

export default Modal;
